const TEST_IDS_CREATE = {
  addOrganizationForm: {
    roleDescription: 'create-person-form-role-description',
    root: 'add-organization-form-root',
    selectOrganizationRoot: 'select-organization-root',
    selectRoleRoot: 'select-role-root',
    submit: 'add-organization-form-submit',
  },
  aiSuggestionBox: {
    accept: 'ai-suggestion-box-accept',
    delete: 'ai-suggestion-box-delete',
    root: 'ai-suggestion-box-root',
  },
  alertMessage: {
    btnCTA: 'alertmessage-btn-cta',
    btnDismiss: 'alertmessage-btn-dismiss',
  },
  avatar: {
    icon: 'avatar-icon',
    image: 'avatar-image',
    initials: 'avatar-initials',
    root: 'avatar-root',
  },
  createOrganizationForm: {
    aiNoResultsBox: 'create-organization-form-ai-no-results-box',
    aiSuggestionBox: 'create-organization-form-ai-suggestion-box',
    cancel: 'create-organization-form-cancel',
    duplicateWarning: 'create-organization-form-duplicate-warning',
    duplicateWarningItem: 'create-organization-form-duplicate-warning-item',
    organizationName: 'create-organization-form-organization-name',
    organizationNameError: 'create-organization-form-organization-name-error',
    organizationType: 'create-organization-form-organization-type',
    organizationTypeError: 'create-organization-form-organization-type-error',
    root: 'create-organization-form-root',
    selectTags: 'create-organization-select-tags',
    showAllFields: 'create-organization-form-show-all-fields',
    submit: 'create-organization-form-submit',
  },
  createPersonForm: {
    alertNoLinkedOrg: 'create-person-form-alert-no-linked-org',
    cancel: 'create-person-form-cancel',
    firstName: 'create-person-form-first-name',
    firstNameError: 'create-person-form-first-name-error',
    lastName: 'create-person-form-last-name',
    lastNameError: 'create-person-form-last-name-error',
    root: 'create-person-form-root',
    selectTags: 'create-person-select-tags',
    showAllFields: 'create-person-form-show-all-fields',
    submit: 'create-person-form-submit',
    title: 'create-person-form-title',
  },
  createRelation: {
    createOrganizationTab: 'create-relation-create-organization-tab',
    createPersonTab: 'create-relation-create-person-tab',
  },
  editPerson: {
    infoHeader: {
      avatar: 'edit-person-info-header-avatar',
      root: 'edit-person-info-header-root',
    },
    root: 'edit-person-root',
  },
  formSelect: {
    input: 'form-select-input',
    options: 'form-select-options',
    trigger: 'form-select-trigger',
  },
  login: {
    email: 'login-email',
    password: 'login-password',
    sso: 'login-sso',
    submit: 'login-submit',
  },
  newMultiSelect: {
    chip: 'edit-person-tags-chip',
    input: 'new-multi-select-input',
    options: 'new-multi-select-options',
    root: 'new-multi-select-root',
    trigger: 'new-multi-select-trigger',
  },
  relationships: {
    createNewButton: 'relationships-create-new-button',
  },
  sectionAddresses: {
    addButton: 'addresses-add-button',
    addressLine1Input: 'addresses-line1-input',
    addressLine2Input: 'addresses-line2-input',
    alternativeRecipientInput: 'addresses-alternative-recipient-input',
    cityInput: 'addresses-city-input',
    countrySelect: 'addresses-country-select',
    inputGrid: 'addresses-input-grid',
    pincodeInput: 'addresses-pincode-input',
    primaryBadge: 'addresses-primary-badge',
    removeButton: 'addresses-remove-button',
    setPrimaryButton: 'addresses-set-primary-button',
    stateInput: 'addresses-state-input',
    titleInput: 'addresses-title-input',
  },
  sectionBankAccountOrganization: {
    bankSelect: 'section-bank-account-organization-bank-select',
    bicInput: 'section-bank-account-organization-bic-input',
    ibanInput: 'section-bank-account-organization-iban-input',
    ownerInput: 'section-bank-account-organization-owner-input',
    root: 'section-bank-account-organization-root',
  },
  sectionEmails: {
    addButton: 'emails-add-button',
    emailInput: 'emails-email-input',
    inputGrid: 'emails-input-grid',
    primaryBadge: 'emails-primary-badge',
  },
  sectionGeneralDataOrganization: {
    description: 'section-general-data-organization-description',
    industry: 'section-general-data-organization-industry',
    metVia: 'section-general-data-organization-met-via',
    organizationName: 'section-general-data-organization-name',
    registerNumber: 'section-general-data-organization-register-number',
    root: 'section-general-data-organization-root',
    taxId: 'section-general-data-organization-tax-id',
    vatNumber: 'section-general-data-organization-vat-number',
  },
  sectionGeneralDataPerson: {
    birthday: 'section-general-data-person-birthday',
    description: 'section-general-data-person-description',
    firstName: 'section-general-data-person-first-name',
    lastName: 'section-general-data-person-last-name',
    metVia: 'section-general-data-person-met-via',
    title: 'section-general-data-person-title',
  },
  sectionImageUpload: {
    root: 'section-image-upload-root',
    uploadInput: 'section-image-upload-upload-input',
  },
  sectionInfoHeader: {
    avatar: 'section-info-header-avatar',
    link: 'section-info-header-link',
    root: 'section-info-header-root',
    tag: 'section-info-header-tag',
  },
  sectionMetaData: {
    kanbanState: 'section-metadata-kanban-state',
    rating: 'section-metadata-rating',
    responsibleEmployee: 'section-metadata-responsible-employee',
    root: 'section-metadata-root',
  },
  sectionOrganizationList: {
    addOrganizationButton: 'section-organization-add-organization-button',
    description: 'edit-person-organizations-description',
    item: 'edit-person-organizations-item',
    list: 'edit-person-organizations-list',
    name: 'edit-person-organizations-name',
    role: 'edit-person-organizations-role',
    root: 'section-organization-root',
  },
  sectionPhoneNumbers: {
    addButton: 'phone-numbers-add-button',
    inputGrid: 'phone-numbers-input-grid',
    numberInput: 'phone-numbers-number-input',
    primaryBadge: 'phone-numbers-primary-badge',
    typeSelect: 'phone-numbers-type-select',
  },
  sectionWeblinks: {
    addButton: 'weblinks-add-button',
    inputGrid: 'weblinks-input-grid',
    typeSelect: 'weblinks-type-select',
    urlInput: 'weblinks-url-input',
  },
  sidebar: {
    salesTab: {
      dashboard: 'sidebar-sales-dashboard',
      deals: 'sidebar-sales-deals',
      quotations: 'sidebar-sales-quotations',
      salesOrders: 'sidebar-sales-salesOrders',
    },
  },
  simpleNotification: {
    link: 'simple-notification-link',
    root: 'simple-notification-root',
  },
  singleSelect: {
    input: 'single-select-input',
    options: 'single-select-options',
    trigger: 'single-select-trigger',
  },
  tagSelect: 'tag-select-root',
  textInput: {
    aiButton: 'text-input-ai-button',
    aiSpinner: 'text-input-ai-spinner',
    sparklesIcon: 'text-input-sparkles-icon',
  },
  topBar: {
    logoutButton: 'top-bar-logout-button',
    profileButton: 'top-bar-profile-button',
  },
}

export { TEST_IDS_CREATE }
